import { ExcursionType } from 'api/types'
import { proxy, useSnapshot } from 'valtio'

export namespace ExCurrent {
    const CurrentExcursion = proxy<{ current: ExcursionType | null }>({ current: null })

    export const set = (raw: ExcursionType) => {
        CurrentExcursion.current = raw
    }

    export const getExCurrentState = () => {
        return { ex_current: CurrentExcursion.current }
    }
}

export namespace PaymentState {
    const isPayed = proxy<{ current: boolean }>({ current: false })

    export const set = (raw: boolean) => {
        isPayed.current = raw
    }

    export const usePaymentState = () => {
        const { current } = useSnapshot(isPayed)
        return { isPayed: current }
    }

    export const getPaymentState = () => {
        return { isPayed: isPayed.current }
    }
}
